import { Box, Text, List, ListItem } from '@sixfold/common-ui';
import React from 'react';

import styles from './not_found_license_plates_styles.module.css';

interface NotFoundLicensePlatesProps {
  notFoundPlates: string[];
}

const NotFoundLicensePlates: React.FC<NotFoundLicensePlatesProps> = ({ notFoundPlates }) => {
  if (!notFoundPlates.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Box className={styles.notFoundBox}>
        <Text variant="subtitle1" color="error" gutterBottom>
          The following license plates were not found:
        </Text>
        <List direction="row" className={styles.inlineList}>
          {notFoundPlates.map((plate, index) => (
            <ListItem key={`${plate}-${index}`}>
              <Text variant="body2">
                {plate.trim()}
                {index < notFoundPlates.length - 1 ? ', ' : ''}
              </Text>
            </ListItem>
          ))}
        </List>
      </Box>
    </div>
  );
};

export default NotFoundLicensePlates;
